import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { cartSlice } from "@src/store/reducers/CartSlice";

const useAutoHideOrderTracking = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(cartSlice.actions.hideOrderTracking());
    return () => {
      dispatch(cartSlice.actions.showOrderTracking());
    };
  }, []);
};

export default useAutoHideOrderTracking;
